import { Directive, HostBinding } from "@angular/core";

/**
 * Marker directive that styles a native `<input type="time">` with the
 * design-system look. Auto-sets `type="time"` so callers can just write
 * `<input bv-time-input>` without remembering the type attribute.
 *
 * Inherits base styling from the same `forms.scss` block as `bv-input`
 * (the selector list there includes `input[bv-time-input]`). Adds
 * dark-theme tinting for the WebKit calendar-picker-indicator clock
 * icon so it remains legible on dark backgrounds.
 *
 *   <bv-form-field label="Time">
 *     <input bv-time-input [(ngModel)]="time" />
 *   </bv-form-field>
 *
 * The bound value is the native `<input type="time">` string format
 * (`"HH:MM"`, 24h), consistent regardless of the user's locale display
 * preference — browsers handle AM/PM vs. 24h presentation automatically
 * based on browser/OS locale.
 */
@Directive({ selector: "input[bv-time-input]" })
export class BvTimeInputDirective {
  @HostBinding("attr.type") readonly type = "time";
}
